import Hero from "@/components/hero";
import Services from "@/components/services";
import AboutUs from "@/components/aboutUs";

const LandingPage = () => {
  return (
    <>
      <Hero />
      <Services />
      <AboutUs />
    </>
  );
};

export default LandingPage;
